import './scss/import.scss';
import MainContainer from "./containers/MainContainer";
import Footer from "./components/Footer";
import Header from './components/Header';

function App() {
  return <>
    <Header />
    <MainContainer />
    <Footer />
  </>;
}

export default App;
